var map = {
	"./0.png": "qWO9",
	"./1.png": "xdgE",
	"./2.png": "zw5Z",
	"./3.png": "OlkL",
	"./4.png": "wTO9",
	"./5.png": "Vpx2",
	"./6.png": "Mike",
	"./7.png": "u4+J"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Azx7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dww ^\.\/.*\.png$
// module id = Azx7
// module chunks = 0